/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";

import NewShortcut from "./NewShortcut";
import { getRequest } from "utils/request";
import { putRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { translate } from "../../../translate/i18n";
import { useModal } from "hooks/modal";
import exportExcel from "utils/exportExcel";
import formatDate from "utils/formatDate";

export default function TabShortcut({ companyData, handleUpdate }) {
  const [shortcut, setShortcut] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onlyActive, setOnlyActive] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const [newShortcut, setNewShortcut] = useState(false);
  const [selectedShortcut, setSelectedShortcut] = useState({});
  const { toggleHelperId } = useModal();

  useEffect(() => {
    const value = JSON.stringify(companyData);
    setGlobalFilter("");
    if (value !== "{}") {
      setLoading(true);
      getRequest(
        `/companiesshortcuts?CompanyId=${companyData.id}&onlyActive=${
          onlyActive ? 1 : 0
        }`
      ).then(function (response) {
        response.data.forEach((e) => {
          if (e.active) {
            e.active = translate("userActive");
          } else {
            e.active = translate("inactive");
          }
        });
        setShortcut(response.data);
        setLoading(false);
      });
    }
  }, [onlyActive]);

  const handleGoBack = () => {
    setNewShortcut(!newShortcut);
  };

  const handleNewShortcut = () => {
    handleUpdate(14);
    setNewShortcut(!newShortcut);
  };

  const handleEditShortcut = (data) => {
    setSelectedShortcut(data);
    setNewShortcut(!newShortcut);
  };

  const handleNew = () => {
    setSelectedShortcut({});
    setNewShortcut(true);
  };

  const handleInactivate = (id) => {
    putRequest(`/companiesshortcuts/inactivate/${id}`).then((response) => {
      if (response.success) {
        handleUpdate(14);
      }
    });
  };

  const handleActivate = (id) => {
    putRequest(`/companiesshortcuts/activate/${id}`).then((response) => {
      if (response.success) {
        handleUpdate(14);
      }
    });
  };

  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 0 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", gap: 10 }}>
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() => handleEditShortcut(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        {data.active === "Ativo" ? (
          <div
            className="action-icon"
            style={{ cursor: "pointer" }}
            onClick={() => handleInactivate(data.id)}
          >
            {/* replace below classname to make an on off icon */}
            <i className="mdi mdi-eye-off-outline" style={{ fontSize: 20 }}></i>
          </div>
        ) : (
          <div
            className="action-icon"
            style={{ cursor: "pointer" }}
            onClick={() => handleActivate(data.id)}
          >
            {/* replace below classname to make an on off icon */}
            <i className="mdi mdi-eye-outline" style={{ fontSize: 20 }}></i>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    toggleHelperId(!newShortcut ? 36 : 37);
  }, [newShortcut]);

  const handleExport = () => {
    let data = [];

    shortcut.forEach((e) => {
      const shortcutAux = {
        Id: e.id,
        [translate("title")]: e.title,
        [translate("message")]: e.message,
        [translate("userActive")]: e.active,
        [translate("createdAt")]: formatDate(e.createdAt),
      };

      data.push(shortcutAux);
    });

    exportExcel(data, translate("attendanceShortcut"));
  };

  return (
    <div className="list-container">
      <div
        className="title-helper-container"
        style={{ marginBottom: !newShortcut && 10, border: !newShortcut && 0 }}
      >
        <h3>{companyData.nickName}</h3>
        {!newShortcut && (
          <button
            style={{ marginBottom: 5 }}
            type="button"
            onClick={handleExport}
            className="export-excel"
          >
            <i
              style={{ fontSize: 16, marginRight: 5 }}
              className="pi pi-file-excel"
            />
            <span style={{ fontSize: "1vw" }}>
              {translate("exportAllData")}
            </span>
          </button>
        )}
      </div>
      {!newShortcut ? (
        <>
          <div className="tab-content">
            <div className="tab-pane show active" id="multi-item-preview">
              {!loading ? (
                <DataTable
                  dataKey="id"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  value={shortcut}
                  header={header}
                  globalFilter={globalFilter}
                  paginator
                  rows={5}
                  emptyMessage={translate("noShortcutFinded")}
                >
                  <Column
                    field="title"
                    header={translate("title")}
                    sortable
                  ></Column>
                  <Column
                    field="message"
                    header={translate("message")}
                    sortable
                  ></Column>
                  <Column
                    field="active"
                    header={translate("status")}
                    sortable
                  ></Column>
                  <Column
                    body={(data) => actionButtonsTemplate(data, shortcut)}
                    field="action"
                    header={translate("action")}
                  ></Column>
                </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <div className="button-add" onClick={() => handleNew()}>
            <i className="mdi mdi-plus"></i>
          </div>
        </>
      ) : (
        <NewShortcut
          handleNewShortcut={handleNewShortcut}
          companyId={companyData.id}
          selectedShortcut={selectedShortcut}
          handleGoBack={handleGoBack}
        />
      )}
    </div>
  );
}
